import { render, staticRenderFns } from "./snippet-browser.vue?vue&type=template&id=4b83110f&"
import script from "./snippet-browser.vue?vue&type=script&lang=js&"
export * from "./snippet-browser.vue?vue&type=script&lang=js&"
import style0 from "./snippet-browser.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports